import React from 'react'

const statusColors = {
  planned: 'border-l-gray-300',
  prepared: 'border-l-emerald-500',
  skipped: 'border-l-red-300',
}

export function MealCard({ meal, onPrepared, onSkip, onEdit, onDelete, onSaveToLibrary }) {
  const statusClass = statusColors[meal.status] ?? statusColors.planned
  return (
    <div className={`bg-white rounded-lg border-l-4 shadow-sm p-3 ${statusClass}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-medium text-gray-800 text-sm truncate">{meal.name || meal.custom_meal || 'Repas'}</p>
          {meal.prep_time && (
            <p className="text-xs text-gray-400 mt-0.5">{meal.prep_time} min</p>
          )}
        </div>
        <div className="flex gap-1 shrink-0 items-center">
          {meal.status === 'planned' && (
            <>
              <button
                onClick={(e) => { e.stopPropagation(); onPrepared?.(meal) }}
                className="text-xs bg-emerald-50 text-emerald-600 hover:bg-emerald-100 px-2 py-1 rounded-md"
                title="Marquer comme préparé"
              >✓</button>
              <button
                onClick={(e) => { e.stopPropagation(); onSkip?.(meal) }}
                className="text-xs bg-red-50 text-red-400 hover:bg-red-100 px-2 py-1 rounded-md"
                title="Passer"
              >✕</button>
            </>
          )}
          {meal.status === 'prepared' && (
            <span className="text-xs text-emerald-600 font-medium">✓ Préparé</span>
          )}
          {meal.status === 'skipped' && (
            <span className="text-xs text-red-400">Passé</span>
          )}
          {onSaveToLibrary && (
            <button
              onClick={(e) => { e.stopPropagation(); onSaveToLibrary(meal) }}
              className="text-gray-400 hover:text-amber-500"
              title="Sauver dans mes plats"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
              </svg>
            </button>
          )}
          {onDelete && (
            <button
              onClick={(e) => { e.stopPropagation(); onDelete(meal) }}
              className="text-gray-300 hover:text-red-500"
              title="Supprimer"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
          {onEdit && (
            <button onClick={(e) => { e.stopPropagation(); onEdit(meal) }} className="text-gray-400 hover:text-gray-600">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
